import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const PublicRoute = ({ auth, ...props }) => {
    const isAllowed = localStorage.getItem('user')
    console.log(isAllowed)
    return isAllowed
        ? (<Redirect to="/" />)
        : (<Route {...props} />)
};